import {
  AdvancedFilterDataSchema,
  FilterGroupSchema,
} from "@redotech/redo-model/views/views";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateOmsPriorityFilter = {
  name: "updateOmsPriorityFilter" as const,
  input: z.object({
    id: zExt.objectId(),
    name: z.string().optional(),
    filters: z.array(AdvancedFilterDataSchema).optional(),
    filterGroup: FilterGroupSchema.optional(),
    position: z.number().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
